
import { defineComponent } from "vue";
import LInput from "@/components/form/LInput.vue";
import LButtom from "@/components/LButtom/LButtom.vue";

export default defineComponent({
  name: "LRecoveryForm",
  components: { LButtom, LInput },
  data() {
    return {
      email: "",
    };
  },
});
